import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import classes from './paymentFailed.module.css';
import Header from '../../components/standartComponents/header';

const PaymentFailed = ({ authUser }) => {
  const navigate = useNavigate();
  const [supModal, setSupModal] = useState(false);
  const [supSent, setSupSent] = useState(false);
  const [showToast, setShowToast] = useState(false);

  const handleSubmitSup = () => {
    setSupSent(true);
    setTimeout(() => {
      setSupModal(false);
      setSupSent(false);
      setShowToast(true);
      setTimeout(() => setShowToast(false), 3000);
    }, 2000); // Simulate sending then close and show toast
  };

  return (
    <>
      <Header authUser={authUser} />
      
      <div className={classes.wrap}>
        {/* HERO */}
        <div className={classes.hero}>
          <div className={classes.warnIcon} style={{ position: 'relative' }}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" x2="12" y1="9" y2="13"/><line x1="12" x2="12.01" y1="17" y2="17"/></svg>
          </div>
          <h1>Оплата не пройшла</h1>
          <p>Не вдалося активувати Premium. Перевірте дані оплати або спробуйте інший спосіб.</p>
          <p className={classes.reassure}>Якщо кошти були списані, зверніться до підтримки — ми допоможемо.</p>
        </div>

        {/* SUMMARY */}
        <div className={classes.summary}>
          <div className={classes.sumT}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="14" x="2" y="5" rx="2"/><line x1="2" x2="22" y1="10" y2="10"/></svg>
            Деталі спроби оплати
          </div>
          <div className={classes.sumGrid}>
            <div className={classes.sumI}><div className={classes.sumL}>Тариф</div><div className={classes.sumV}>Premium</div></div>
            <div className={classes.sumI}><div className={classes.sumL}>Статус</div><div className={`${classes.sumV} ${classes.fail}`}>✕ Не оплачено</div></div>
            <div className={classes.sumI}><div className={classes.sumL}>Сума</div><div className={classes.sumV}>299 грн / міс</div></div>
            <div className={classes.sumI}><div className={classes.sumL}>Спроба</div><div className={classes.sumV}>19.05.2026</div></div>
            <div className={classes.sumI}><div className={classes.sumL}>Оплата</div><div className={classes.sumV}>Visa **** 1234</div></div>
          </div>
          <div className={classes.sumReason}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>
            Причина: платіж не підтверджено банком
          </div>
        </div>

        {/* ACTIONS */}
        <div className={classes.actions}>
          <button className={classes.btnRetry} onClick={() => navigate('/pricing')}>
            Спробувати ще раз<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
          </button>
          <div className={classes.actRow}>
            <button className={classes.actSec} onClick={() => navigate('/pricing')}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="14" x="2" y="5" rx="2"/><line x1="2" x2="22" y1="10" y2="10"/></svg>
              Обрати інший спосіб оплати
            </button>
            <Link to="/pricing" className={classes.actSec} style={{ textDecoration: 'none' }}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></svg>
              Повернутися до тарифів
            </Link>
          </div>
        </div>

        {/* REASONS */}
        <div className={classes.reasons}>
          <div className={classes.reasonsT}>Що могло статися?</div>
          <div className={classes.reasonsList}>
            <div className={classes.reasonItem}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4"/><path d="M12 16h.01"/></svg>Недостатньо коштів на картці</div>
            <div className={classes.reasonItem}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4"/><path d="M12 16h.01"/></svg>Банк відхилив платіж</div>
            <div className={classes.reasonItem}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4"/><path d="M12 16h.01"/></svg>Неправильні дані картки</div>
            <div className={classes.reasonItem}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4"/><path d="M12 16h.01"/></svg>Не пройдено підтвердження 3D Secure</div>
            <div className={classes.reasonItem}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4"/><path d="M12 16h.01"/></svg>Тимчасова помилка платіжної системи</div>
          </div>
        </div>

        {/* SUPPORT */}
        <div className={classes.supportCard}>
          <div className={classes.supIcon}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
          </div>
          <div className={classes.supBody}>
            <h4>Потрібна допомога?</h4>
            <p>Напишіть нам, якщо оплата не проходить повторно або якщо кошти були списані.</p>
          </div>
          <button className={classes.supBtn} onClick={() => setSupModal(true)}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
            Підтримка
          </button>
        </div>

        {/* FREE LINK */}
        <div className={classes.freeLink}>
          <Link to="/allvideos">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
            Продовжити без Premium
          </Link>
        </div>
      </div>

      {/* FOOTER */}
      <div className={classes.foot}>
        <div className={classes.footIn}>
          <div className={classes.footC}>© 2026 AI Lingua. Всі права захищені.</div>
          <div className={classes.footL}>
            <Link to="/termsOfUse">Умови використання</Link>
            <Link to="/privacy">Політика конфіденційності</Link>
            <Link to="/cancelAndRefund">Повернення коштів</Link>
          </div>
        </div>
      </div>

      {/* SUPPORT MODAL */}
      {supModal && (
        <div className={classes.ov} onClick={() => { setSupModal(false); setSupSent(false); }}>
          <div className={classes.mod} onClick={(e) => e.stopPropagation()}>
            {!supSent ? (
              <div>
                <div className={classes.modT}>Звернення до підтримки</div>
                <div className={classes.modS}>Опишіть проблему з оплатою, і ми допоможемо.</div>
                <div className={classes.topicPre}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>
                  Тема: Проблема з оплатою
                </div>
                <div className={classes.fg}>
                  <label className={classes.fl}>Email</label>
                  <input className={classes.fi} type="email" defaultValue={authUser?.email || "alina@gmail.com"} />
                </div>
                <div className={classes.fg}>
                  <label className={classes.fl}>Повідомлення</label>
                  <textarea className={classes.fi} style={{ resize: 'vertical', minHeight: '80px' }} placeholder="Опишіть, що сталося з оплатою…"></textarea>
                </div>
                <div className={classes.modBtns}>
                  <button className={classes.mc} onClick={() => setSupModal(false)}>Скасувати</button>
                  <button className={classes.ms} onClick={handleSubmitSup}>Надіслати</button>
                </div>
              </div>
            ) : (
              <div style={{ textAlign: 'center', padding: '20px 0' }}>
                <div style={{ width: '48px', height: '48px', borderRadius: '50%', background: 'linear-gradient(135deg,#34D399,#10B981)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 14px', boxShadow: '0 4px 16px rgba(16,185,129,.25)' }}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ width: '24px', height: '24px' }}><path d="M20 6 9 17l-5-5"/></svg>
                </div>
                <div style={{ fontFamily: "'Sora', sans-serif", fontSize: '16px', fontWeight: '700', marginBottom: '4px' }}>Дякуємо!</div>
                <div style={{ fontSize: '13px', color: 'var(--text-2)', marginBottom: '20px' }}>Ми отримали звернення і відповімо на вашу пошту.</div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* TOAST */}
      <div className={`${classes.toast} ${showToast ? classes.show : ''}`}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
        Дякуємо! Ми отримали звернення.
      </div>
    </>
  );
};

export default PaymentFailed;
